import React, { useContext, useEffect, useRef, useState } from "react";
import classes from "./AboutUs.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { t } from "../../locales/i18n";
import Header from "../../components/Header/Header";
import { Helmet } from "react-helmet";
import BookNowBtn from "../../components/BookNowBtn";
import FooterInfo from "../../components/FooterInfo/FooterInfo";
import FloatingButton from "../../components/FloatingButton/FloatingButton";
import { ReactPhotoCollage } from "react-photo-collage";
import { images } from "../../assets/img";
import useCheckIsMobile from "../../hook/useCheckIsMobile";
import { NAIL_SHOP_INFO } from "../../utils/Const";

const PHOTOS = [
  { source: "https://i.imgur.com/8a2SAYg.jpeg" },
  { source:images.nail1 },
  { source: images.nail2 },
  { source: images.nail3 },
  { source: images.nail4 },
  { source: "https://i.imgur.com/Taim0rU.jpeg" },
  { source: images.nail4 },
  { source: "https://i.imgur.com/49oxWuK.jpeg" },
];

const AboutUs = () => {
  const navigate = useNavigate();
  const isMobile = useCheckIsMobile();

  const [collageLayout, setCollageLayout] = useState([]);
  const [collageHeight, setCollageHeight] = useState([]);

  useEffect(() => {
    const { layout, height } = generateLayoutAndHeight(PHOTOS.length) || {};
    setCollageLayout(layout);
    setCollageHeight(height);
  }, []);

  function generateLayoutAndHeight(imageCount) {
    const mobileHeightRange = { min: 23, max: 36 };
    const otherHeightRange = { min: 30, max: 47 };

    // Function to generate random numbers between a range
    const getRandomInRange = (min, max) =>
      Math.floor(Math.random() * (max - min + 1)) + min;

    // Function to generate random layout arrays
    const getRandomLayout = (isMobile) => {
      const maxItems = isMobile ? 3 : 4; // max 3 for mobile, 4 for others
      const layout = [];
      let totalImages = 0;

      while (totalImages < imageCount) {
        const numItems = getRandomInRange(1, maxItems);
        layout.push(numItems);
        totalImages += numItems;
      }
      return layout;
    };

    // Get randomized layout array
    const layout = getRandomLayout(isMobile);

    // Generate matching height array based on the layout
    const height = layout.map(() => {
      return isMobile
        ? `${getRandomInRange(mobileHeightRange.min, mobileHeightRange.max)}rem`
        : `${getRandomInRange(otherHeightRange.min, otherHeightRange.max)}rem`;
    });

    return { layout, height };
  }

  return (
    <div className={classes.container}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"About us"}</title>
        <meta name="about-us" content="About us" />
      </Helmet>
      <Header selected={"about-us"} />

      <div className={classes.introTextContainer}>
        <div>
          <h1>{"Where Beauty Meets Serenity"}</h1>
          <h3 className={classes.greyIntroTextContainer}>
            {NAIL_SHOP_INFO.name} – A Premier Destination for Refined Elegance
          </h3>
        </div>
        <p className={classes.greyIntroTextContainer}>
          At {NAIL_SHOP_INFO.name}, we blend exceptional artistry with a
          tranquil ambiance to create an experience of true indulgence. From
          timeless classics such as a perfect manicure to bespoke, hand-crafted
          nail art, our dedicated team is committed to transforming your vision
          into a masterpiece.
        </p>
        <p className={classes.greyIntroTextContainer}>
          {`Each visit is more than a treatment—it is a moment of relaxation, rejuvenation, and luxury. With meticulous attention to detail and the highest standards of care, we ensure your nails not only look flawless but remain healthy and radiant.\nDiscover why discerning guests choose Blue Pearl Nail Spa as their sanctuary for beauty, wellness, and elegance.`}
        </p>
      </div>

      {collageLayout && collageLayout.length > 0 && (
        <ReactPhotoCollage
          width={"100%"}
          layout={collageLayout}
          height={collageHeight}
          photos={PHOTOS}
          showNumOfRemainingPhotos
        />
      )}

      <h1>Gift Voucher Available</h1>
      <BookNowBtn style={classes.bookNowBtnStyle} />

      <FooterInfo style={classes.footerStyle} />
      <FloatingButton />
    </div>
  );
};

export default AboutUs;
